/* @flow */

import * as React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

import { addPxToInput, ensureAbsoluteUrl } from '../../../../shared'
import {
  NAVIGATION_LINK_TYPE_SEARCH,
  NAVIGATION_LINK_TYPE_PAGE,
  NAVIGATION_LINK_TYPE_BESTSELLERS,
  WebshopContext,
} from '../../../shared'
import WebshopLinkButton from '../../WebshopLinkButton'
import { WidgetContainer } from '../shared'

const WebshopLinkButtonWidget = ({ brand, gridItem, ...rest }) => {
  const { navigationLinks } = React.useContext(WebshopContext)

  const navigationLinksIdToUrlMap = React.useMemo(() => {
    return navigationLinks.reduce((acc, link) => {
      let url = ''

      if (
        link.type === NAVIGATION_LINK_TYPE_SEARCH ||
        link.type === NAVIGATION_LINK_TYPE_BESTSELLERS
      ) {
        url = `/shop/${brand.id}/search/${link.id}`
      } else if (link.type === NAVIGATION_LINK_TYPE_PAGE) {
        url = `/shop/${brand.id}/page/${link.settings.page_id}`
      }

      acc[link.id] = url
      return acc
    }, {})
  }, [navigationLinks])

  const sharedLinkButtonProps = {
    color: 'white',
    styleId: gridItem.data.button_style,
    size: gridItem.data.button_size,
  }

  return (
    <Container gridItem={gridItem}>
      <ButtonsContainer gridItem={gridItem}>
        {gridItem.data.link_buttons.map((linkButton, index) => (
          <React.Fragment key={index}>
            {linkButton.link_type === 'manual_url' && (
              <WebshopLinkButton
                {...sharedLinkButtonProps}
                useSimpleATag
                href={ensureAbsoluteUrl(linkButton.manual_url)}
              >
                {linkButton.button_text}
              </WebshopLinkButton>
            )}
            {linkButton.link_type === 'webshop_page' && (
              <WebshopLinkButton
                {...sharedLinkButtonProps}
                to={
                  linkButton.webshop_page_id
                    ? `/shop/${brand.id}/page/${linkButton.webshop_page_id}`
                    : ''
                }
              >
                {linkButton.button_text}
              </WebshopLinkButton>
            )}
            {linkButton.link_type === 'navigation_link' && (
              <WebshopLinkButton
                {...sharedLinkButtonProps}
                to={
                  linkButton.navigation_link_id &&
                  navigationLinksIdToUrlMap[linkButton.navigation_link_id]
                    ? navigationLinksIdToUrlMap[linkButton.navigation_link_id]
                    : ''
                }
              >
                {linkButton.button_text}
              </WebshopLinkButton>
            )}
          </React.Fragment>
        ))}
      </ButtonsContainer>
    </Container>
  )
}

export default WebshopLinkButtonWidget

const Container = styled(WidgetContainer)`
  width: 100%;
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: ${({ gridItem }) =>
    gridItem.data.stack_mode === 'stacked' ? 'column' : 'row'};

  & > * {
    flex: 0 0 auto;
  }

  ${({ gridItem }) =>
    gridItem.data.stack_mode === 'side_by_side' &&
    css`
      & > * {
        margin-left: ${addPxToInput(gridItem.data.space_between_each)};

        &:first-child {
          margin-left: 0;
        }
      }
    `}

  ${({ gridItem }) =>
    gridItem.data.stack_mode === 'stacked' &&
    css`
      & > * {
        margin-top: ${addPxToInput(gridItem.data.space_between_each)};

        &:first-child {
          margin-top: 0;
        }
      }
    `}
`
